import React, { useContext, useEffect } from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { DataProvider } from "./contexts/DataContext";
import Hyper from "./Theme/Hyper";
import Main from "./components/Views/Main";
import { ControlContext, ControlProvider } from "./contexts/ControlContext";
import { GraphicsContext, GraphicsProvider } from "./contexts/GraphicsContext";
import { UIContext, UIProvider } from "./contexts/UIContext";
import Config from "./components/Views/Config";
import Live from "./components/Live/Live";
import WindowTitleBar from "./components/WindowTitleBar/WindowTitleBar";
import Management from "./components/Management/Management";
import { APIProvider } from "./contexts/APIContext";
import NavBar from "./components/TopBar/NavBar";
import { MonitorContext, MonitorProvider } from "./contexts/MonitorContext";
import ProjectSelect from "./components/ProjectSelect/ProjectSelect";

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function App() {
  window.hyperLink = window.localStorage.getItem("hyperLink") || "127.0.0.1";
  window.MSEAddress = window.localStorage.getItem("MSEAddress") || "127.0.0.1";
  window.showName =
    window.localStorage.getItem("showName") || "SkySports_Football";
  window.vizProfile = window.localStorage.getItem("vizProfile") || "default";
  window.dataUrl =
    window.localStorage.getItem("dataUrl") ||
    "ws://skyfootballdata.hyperstudios.live";
  window.dataUrl = "ws://opta.hyperstudios.live:8082";
  window.dataUrl = "ws://109.228.39.127:8082";
  window.dataUrl = "ws://localhost:8082";
  window.command_server =
    getParameterByName("command_server") ||
    window.ENV?.REACT_APP_COMMAND_SERVER ||
    process.env.REACT_APP_COMMAND_SERVER;
  window.monitor_server =
    getParameterByName("mnonitor_server") ||
    window.ENV?.REACT_APP_MONITOR_SERVER ||
    process.env.REACT_APP_MONITOR_SERVER;
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <ThemeProvider theme={Hyper}>
        <MonitorProvider>
          <ControlProvider>
            <GraphicsProvider>
              <DataProvider>
                <APIProvider>
                  <ProjectGate>
                    <ShowMain>
                      <Switch>
                        <Route path="/Config">
                          <Config />
                        </Route>
                        <Route path="/">
                          <Main />
                        </Route>
                      </Switch>
                    </ShowMain>
                  </ProjectGate>
                </APIProvider>
              </DataProvider>
            </GraphicsProvider>
          </ControlProvider>
        </MonitorProvider>
      </ThemeProvider>
    </Router>
  );
}
function ProjectGate({ children }) {
  const { projectId, showProjectSelect } = useContext(ControlContext);
  // No project resolved from URL param, remembered choice, or env default:
  // prompt the user to pick one before loading the app. The picker can also
  // be reopened on demand via the "Change project" button rendered beside the
  // engine preview iframe (see components/Engine/Engine.js).
  if (!projectId || showProjectSelect) {
    return <ProjectSelect />;
  }
  return children;
}
function ShowMain({ children }) {
  const { uiView, setUIView } = useContext(UIContext);
  const { clearPVW, graphicInPreview } = useContext(GraphicsContext);
  const { clear, selectedEngine } = useContext(ControlContext);
  const { monitorItems } = useContext(MonitorContext);
  useEffect(() => {
    function handleKeyDown(e) {
      console.log(e.keyCode);

      if (e.keyCode === 112) {
        setUIView(0);
      }
      if (e.keyCode === 113) {
        setUIView(1);
      }
      if (e.keyCode === 114) {
        setUIView(2);
      }
      if (e.keyCode === 81 && e.ctrlKey && !e.shiftKey) {
        if (graphicInPreview && graphicInPreview.name) {
          clearPVW(graphicInPreview.name);
        }
      }

      if (e.keyCode === 81 && e.ctrlKey && e.shiftKey) {
        if (graphicInPreview && graphicInPreview.name) {
          clearPVW(graphicInPreview.name);
        }
        clear();
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [graphicInPreview]);

  const connectedEngine =
    window.engines?.find((engine) => engine.key === selectedEngine)?.key ||
    window.engines?.[0]?.key;
  // Only count football clients whose keep-alive is recent, so a stale/ghost
  // session still listed by the monitor server can't trip the banner. The app
  // refreshes monitor_keep_alive every 20s (see MonitorContext keep_alive).
  const FRESH_MS = 60000;
  const matchingApps = (monitorItems || []).filter((item) => {
    const itemEngine = item?.engine || item?.engineId || item?.engine_id;
    const keepAlive = item?.monitor_keep_alive || 0;
    return (
      item?.app === "football" &&
      itemEngine &&
      itemEngine === connectedEngine &&
      Date.now() - keepAlive < FRESH_MS
    );
  });
  const showMultiAppAlert = matchingApps.length > 1;

  // Expose the banner height so 100vh layouts (e.g. the left nav) can subtract
  // it and keep their bottom icons on-screen while the banner is shown.
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--banner-offset",
      showMultiAppAlert ? "50px" : "0px",
    );
  }, [showMultiAppAlert]);

  return (
    <div
      style={{ display: uiView === 1 || !window.process ? "block" : "none" }}
    >
      {showMultiAppAlert && (
        <div
          style={{
            height: "50px",
            boxSizing: "border-box",
            background:
              "linear-gradient(90deg, #7f1d1d 0%, #b91c1c 45%, #dc2626 100%)",
            borderBottom: "3px solid #450a0a",
            boxShadow: "0 6px 18px rgba(127, 29, 29, 0.35)",
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: 800,
            letterSpacing: "0.04em",
            padding: "0 18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          Multiple football apps connected to your engine
        </div>
      )}
      {children}
    </div>
  );
}
export default App;
